import { render, staticRenderFns } from "./history-result.vue?vue&type=template&id=00231661&"
import script from "./history-result.vue?vue&type=script&lang=js&"
export * from "./history-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports